'use strict';

require("core-js/modules/es6.function.bind");

exports.atob = self.atob.bind(self);
exports.btoa = self.btoa.bind(self);